/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

export const mockPluginCatalog = {
  success: true,
  count: 2,
  storageType: 's3',
  manifests: [
    {
      packageName: '@opengeoweb-sandbox/metagotchi',
      manifest: {
        name: '@opengeoweb-sandbox/metagotchi',
        versions: {
          '0.0.5': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.5',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.5',
            readmeFilename: 'README.md',
            gitHead: '173e16e86e6cf1dd485e796e8814221ddf005977',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-YKJQ3lBcHSLymlr1w/FxhLk+HvzE9xQcxEYlrk5OatCbjO2HxSxOdfY+Hd9CgD+KOrkRTrLM8NlhKvP0SIYkNg==',
              shasum: '806693274786a37005cb40f0a347e940b13be8e2',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.5.tgz',
            },
            contributors: [],
          },
          '0.0.6': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.6',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.6',
            readmeFilename: 'README.md',
            gitHead: 'c9f377bff82889b56e22099f60c72510e1b67b2c',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-3ZC+yrthThMYQy2rnEfDP69Hj3AcfFLvT0qxFUhVJ36whEp9xKRFg1D0Ia0WERTwraFT8l/oIVOontezdqrMxQ==',
              shasum: 'f3f19ad74f1376fca1ac17b0793b731836028e50',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.6.tgz',
            },
            contributors: [],
          },
          '0.0.7': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.7',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.7',
            readmeFilename: 'README.md',
            gitHead: '28185f0568279d0c771dba40659f9a0c192ca151',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-IpHkic9sMdfpAvutXNFKPNKdf3JXsNO4tR12AJ0muTqJnDG4/xNL3kXYK2iG7RVbZKpVa5PsSrUCnkz0kn5qvA==',
              shasum: '8ce4f081b1f37badaa444b7e0b7cf8da94726756',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.7.tgz',
            },
            contributors: [],
          },
          '0.0.8': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.8',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js', 'dist/plugin-1_webpack.es'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.8',
            readmeFilename: 'README.md',
            gitHead: '3045df2e836d9ee8973c9a817b307addf85ee561',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-5QiCuHGl8Ww+KmoQxCn/90dNfA3QmCfb3R7XA02h3rC6ir5hH5UaJXXwr4wkfoKwwcLfkGSuh4xmn6wwtOdUzg==',
              shasum: '9b95dc98f5525f5ec84565ed6a602487401f0ac9',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.8.tgz',
            },
            contributors: [],
          },
          '0.0.9': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.9',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js', 'dist/plugin-1_webpack.es'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.9',
            readmeFilename: 'README.md',
            gitHead: 'd317fe69f29f44f9bf2fe001a64d1facf63ba5a4',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-gCpteXpBccAbzyoJ3tqNt8e8PwOPRV4fAO69Qjpe/sTx5qmBPLwfFMZiGsRpoffF8ZyMFbmsSB6X9NolnxvBnA==',
              shasum: 'a192e4aa02b28d79769f3931881e8c900175d883',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.9.tgz',
            },
            contributors: [],
          },
          '0.0.10': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.10',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js', 'dist/plugin-1_webpack.es'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.10',
            readmeFilename: 'README.md',
            gitHead: '09b9071a9694d6c98d4566bdad2977008a5e07f1',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-VEVz4NZ8uOMm8JpmrAj19femxsoul9Ec0VMIXZi5ztctth38wE6+6Vy/Bp3+Qc9I2Nf7gCS+sGMNzaBcYNRecg==',
              shasum: '0b291cf50c06758a179f5524110d0573b827d797',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.10.tgz',
            },
            contributors: [],
          },
          '0.0.11': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.11',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js', 'dist/plugin-1_webpack.es'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              'dev:build': 'npm run build:webpack && npm run dev',
              'dev:watch':
                'npm run build:webpack && webpack --mode production --watch & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.11',
            readmeFilename: 'README.md',
            gitHead: 'f890abb38a5d8c7a51cea6b3ef101d4535809e9f',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-qbrBsbYIE4015PLKY11s3yX8mZVEN0Ua6YgDU1gRP2Tnqk/nP2Q2nnv6T1rUegELgh5m9UNMo/01s7vBoaEPvQ==',
              shasum: '13cec271fee7a8880f8e0c71f226ea535cdd5c28',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.11.tgz',
            },
            contributors: [],
          },
          '0.0.12': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.12',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/bundle.js'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                bundle: 'dist/bundle.js',
              },
            },
            scripts: {
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              dev: 'vite dev',
              build: 'vite build',
              preview: 'vite preview',
              'host-plugin': 'serve --cors -l 9292 ./dist',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.12',
            readmeFilename: 'README.md',
            gitHead: '4eb8fe11ae4a9800c39d4f0f5f2ecbfdf53d2acf',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-hq7aGfbDSQOm63nSfGneyX+hwXtkLuhQtAyyHI0LA2jOSq2pdPFLzKRK9lmDsFtuaQMHX//OtIaoQbd8I0jacQ==',
              shasum: '49126717e95417de8958c8d65cb193aa0c873640',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.12.tgz',
            },
            contributors: [],
          },
          '0.0.13': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.13',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/bundle.js'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                bundle: 'dist/bundle.js',
              },
            },
            scripts: {
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              dev: 'vite dev',
              build: 'vite build',
              preview: 'vite preview',
              'host-plugin': 'serve --cors -l 9292 ./dist',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/react-vite': '^10.2.17',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.13',
            readmeFilename: 'README.md',
            gitHead: '46010ebef3399b2fe4e07b9b3a776b9c2ebd92ac',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-AUAM+sluGpxE8m9oUw3KeOeM900TjLg5lQ5iR0AXUuAkpBG4ImHSjOKoaf8BTi6jo8vDP7A3JP4/Y3/+SPs2Vg==',
              shasum: 'cc423f76391636b2376df2912b80c43b28088305',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.13.tgz',
            },
            contributors: [],
          },
          '0.0.14': {
            name: '@opengeoweb-sandbox/metagotchi',
            version: '0.0.14',
            description: 'Metagotchi plugin',
            author: '',
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/bundle.js'],
            geoweb: {
              plugin: {
                type: 'view',
                scopes: ['time'],
                bundle: 'dist/bundle.js',
              },
            },
            scripts: {
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              dev: 'vite dev',
              build: 'vite build',
              preview: 'vite preview',
              'host-plugin': 'serve --cors -l 9292 ./dist',
              format: 'prettier --write .',
              'check-format': 'prettier --check .',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              're-resizable': '^6.11.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/react-vite': '^10.2.17',
              '@types/react': '^18.3.1',
              '@types/react-dom': '^18.3.1',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              serve: '14.2.5',
              storybook: '^10.0.8',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
            },
            _id: '@opengeoweb-sandbox/metagotchi@0.0.14',
            readmeFilename: 'README.md',
            gitHead: '903716a22759cd32b96ea0bcf748ba77b0f93551',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-FItfEhHJ5jNnykhnKckyUCCP2hxZUNLRZe/7+vecjyIBigOPd+Q9CZxZgwMMQzRh41SzGr7SwbDwZ/CafXPBnQ==',
              shasum: '0e31f238685dc67c315078336fc8621d24cd88b8',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/metagotchi/-/@opengeoweb-sandbox/metagotchi-0.0.14.tgz',
            },
            contributors: [],
          },
        },
        time: {
          modified: '2026-03-11T09:43:45.343Z',
          created: '2026-02-18T11:54:28.438Z',
          '0.0.5': '2026-02-18T11:54:28.438Z',
          '0.0.6': '2026-02-18T12:59:24.111Z',
          '0.0.7': '2026-02-18T13:45:29.761Z',
          '0.0.8': '2026-02-19T05:46:03.464Z',
          '0.0.9': '2026-02-19T12:38:13.587Z',
          '0.0.10': '2026-02-19T12:57:47.761Z',
          '0.0.11': '2026-02-19T13:11:08.146Z',
          '0.0.12': '2026-03-09T15:22:07.347Z',
          '0.0.13': '2026-03-11T09:32:59.071Z',
          '0.0.14': '2026-03-11T09:43:45.343Z',
        },
        users: {},
        'dist-tags': {
          latest: '0.0.14',
        },
        _uplinks: {},
        _distfiles: {},
        _attachments: {
          'metagotchi-0.0.5.tgz': {
            shasum: '806693274786a37005cb40f0a347e940b13be8e2',
            version: '0.0.5',
          },
          'metagotchi-0.0.6.tgz': {
            shasum: 'f3f19ad74f1376fca1ac17b0793b731836028e50',
            version: '0.0.6',
          },
          'metagotchi-0.0.7.tgz': {
            shasum: '8ce4f081b1f37badaa444b7e0b7cf8da94726756',
            version: '0.0.7',
          },
          'metagotchi-0.0.8.tgz': {
            shasum: '9b95dc98f5525f5ec84565ed6a602487401f0ac9',
            version: '0.0.8',
          },
          'metagotchi-0.0.9.tgz': {
            shasum: 'a192e4aa02b28d79769f3931881e8c900175d883',
            version: '0.0.9',
          },
          'metagotchi-0.0.10.tgz': {
            shasum: '0b291cf50c06758a179f5524110d0573b827d797',
            version: '0.0.10',
          },
          'metagotchi-0.0.11.tgz': {
            shasum: '13cec271fee7a8880f8e0c71f226ea535cdd5c28',
            version: '0.0.11',
          },
          'metagotchi-0.0.12.tgz': {
            shasum: '49126717e95417de8958c8d65cb193aa0c873640',
            version: '0.0.12',
          },
          'metagotchi-0.0.13.tgz': {
            shasum: 'cc423f76391636b2376df2912b80c43b28088305',
            version: '0.0.13',
          },
          'metagotchi-0.0.14.tgz': {
            shasum: '0e31f238685dc67c315078336fc8621d24cd88b8',
            version: '0.0.14',
          },
        },
        _rev: '30-0e303494efd97f84',
        _id: '@opengeoweb-sandbox/metagotchi',
        readme: '# Metagotchi Plugin\n\nMetagotchi plugin for GeoWeb.\n',
      },
    },
    {
      packageName: '@opengeoweb-sandbox/timeslider-lite-plugin',
      manifest: {
        name: '@opengeoweb-sandbox/timeslider-lite-plugin',
        versions: {
          '0.0.1': {
            name: '@opengeoweb-sandbox/timeslider-lite-plugin',
            version: '0.0.1',
            description: 'Timeslider lite',
            author: {
              name: 'Henrik Janson, Sampo Savolainen, Pauli Sairanen, Sander de Snaijer',
            },
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js'],
            geoweb: {
              plugin: {
                type: 'overlay',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              'compare-builds': 'npx serve . -l 8080',
              'host-plugin-vite':
                'vite build --watch & serve --cors -l 3030 dist-vite/',
              test: 'vitest',
              'test:run': 'vitest run',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/node': '^24.10.1',
              '@types/react': '^19.2.2',
              '@types/react-dom': '^19.2.2',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              rollup: '^4.57.1',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              vitest: '^4.0.14',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/timeslider-lite-plugin@0.0.1',
            readmeFilename: 'README.md',
            gitHead: 'f180fff2b8eac3a3e471e57dcc1f34f2efff4c93',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-biseCwgFZEII6awvXv3pJW3p9iBROgQL89RKzchKZxqOwLnbRSPH5JBdzta+7YzQLFwbX0ZfLluPsNcBTaRaLA==',
              shasum: '958c4abc255a2551688b8dc29fe99a6d305fd557',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/timeslider-lite-plugin/-/@opengeoweb-sandbox/timeslider-lite-plugin-0.0.1.tgz',
            },
            contributors: [],
          },
          '0.0.2': {
            name: '@opengeoweb-sandbox/timeslider-lite-plugin',
            version: '0.0.2',
            description: 'Timeslider lite',
            author: {
              name: 'Henrik Janson, Sampo Savolainen, Pauli Sairanen, Sander de Snaijer',
            },
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js'],
            geoweb: {
              plugin: {
                type: 'overlay',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              'compare-builds': 'npx serve . -l 8080',
              'host-plugin-vite':
                'vite build --watch & serve --cors -l 3030 dist-vite/',
              test: 'vitest',
              'test:run': 'vitest run',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/node': '^24.10.1',
              '@types/react': '^19.2.2',
              '@types/react-dom': '^19.2.2',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              rollup: '^4.57.1',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              vitest: '^4.0.14',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/timeslider-lite-plugin@0.0.2',
            readmeFilename: 'README.md',
            gitHead: '468bb033e0e51077c3394b810bb5db8b674edd37',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-lSVfL1aemBJDT3YoWrjdVK1ypX8OYzVODapEMfvfMg8N5aGrFDBjstvKJOjuz/J0voakWc5cMmtRADlH+MUGYQ==',
              shasum: '508a11245c2a6f4459539a3a30a758a673bcb3a4',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/timeslider-lite-plugin/-/@opengeoweb-sandbox/timeslider-lite-plugin-0.0.2.tgz',
            },
            contributors: [],
          },
          '0.0.3': {
            name: '@opengeoweb-sandbox/timeslider-lite-plugin',
            version: '0.0.3',
            description: 'Timeslider lite',
            author: {
              name: 'Henrik Janson, Sampo Savolainen, Pauli Sairanen, Sander de Snaijer',
            },
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/plugin-1_webpack.js'],
            geoweb: {
              plugin: {
                type: 'overlay',
                scopes: ['time'],
                distArtifact: 'dist/plugin-1_webpack.js',
              },
            },
            scripts: {
              dev: 'webpack -w & serve --cors -l 9292 ./dist',
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              'dev:vite': 'vite dev',
              'build:webpack': 'webpack --mode production',
              'build:vite': 'vite build',
              'preview:vite': 'vite preview',
              'compare-builds': 'npx serve . -l 8080',
              'host-plugin-vite':
                'vite build --watch & serve --cors -l 3030 dist-vite/',
              test: 'vitest',
              'test:run': 'vitest run',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/node': '^24.10.1',
              '@types/react': '^19.2.2',
              '@types/react-dom': '^19.2.2',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              rollup: '^4.57.1',
              serve: '14.2.5',
              storybook: '^10.0.8',
              'ts-loader': '^9.5.4',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              vitest: '^4.0.14',
              webpack: '^5.102.1',
              'webpack-cli': '^6.0.1',
            },
            _id: '@opengeoweb-sandbox/timeslider-lite-plugin@0.0.3',
            readmeFilename: 'README.md',
            gitHead: '47cb939a93f7de95f142c09e275eebc59dbe81f1',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-NQwWmaRwjqu/LOykw7lHEtkHpn0aIsW2ZX+z0zJjpn82Y1fY1ToAYQ4squzpAURyIEoz5HvpqLNx3Euf8Bsoag==',
              shasum: 'a018b91ebb1038ff243eee8f6aa9fe3ef085ae0f',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/timeslider-lite-plugin/-/@opengeoweb-sandbox/timeslider-lite-plugin-0.0.3.tgz',
            },
            contributors: [],
          },
          '0.0.4': {
            name: '@opengeoweb-sandbox/timeslider-lite-plugin',
            version: '0.0.4',
            description: 'Timeslider lite',
            author: {
              name: 'Henrik Janson, Sampo Savolainen, Pauli Sairanen, Sander de Snaijer',
            },
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/bundle.js'],
            geoweb: {
              plugin: {
                type: 'overlay',
                scopes: ['time'],
                bundle: 'dist/bundle.js',
              },
            },
            scripts: {
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              dev: 'vite dev',
              build: 'vite build',
              preview: 'vite preview',
              'host-plugin': 'vite build --watch & serve --cors -l 3030 dist/',
              test: 'vitest',
              'test:run': 'vitest run',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/addon-webpack5-compiler-swc': '^4.0.2',
              '@storybook/react-webpack5': '^10.0.8',
              '@types/node': '^24.10.1',
              '@types/react': '^19.2.2',
              '@types/react-dom': '^19.2.2',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              rollup: '^4.57.1',
              serve: '14.2.5',
              storybook: '^10.0.8',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              vitest: '^4.0.14',
            },
            _id: '@opengeoweb-sandbox/timeslider-lite-plugin@0.0.4',
            readmeFilename: 'README.md',
            gitHead: '96b17d40d860a3cb12427838535722b26f46776e',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-JLp/fVmbj8I7xldWx93YdS+dfB27GjE11203yQx8N1lObF2NGA33POW3GW1BzgVaQICnSMisl7/N76+tWAnxMQ==',
              shasum: '1b085703c98a027e8595bdba0af0fd9491fc8f14',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/timeslider-lite-plugin/-/@opengeoweb-sandbox/timeslider-lite-plugin-0.0.4.tgz',
            },
            contributors: [],
          },
          '0.0.5': {
            name: '@opengeoweb-sandbox/timeslider-lite-plugin',
            version: '0.0.5',
            description: 'Timeslider lite',
            author: {
              name: 'Henrik Janson, Sampo Savolainen, Pauli Sairanen, Sander de Snaijer',
            },
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/bundle.js'],
            geoweb: {
              plugin: {
                type: 'overlay',
                scopes: ['time'],
                bundle: 'dist/bundle.js',
              },
            },
            scripts: {
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              dev: 'vite dev',
              build: 'vite build',
              preview: 'vite preview',
              'host-plugin': 'vite build --watch & serve --cors -l 3030 dist/',
              test: 'vitest',
              'test:run': 'vitest run',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/react-vite': '^10.2.17',
              '@types/node': '^24.10.1',
              '@types/react': '^19.2.2',
              '@types/react-dom': '^19.2.2',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              rollup: '^4.57.1',
              serve: '14.2.5',
              storybook: '^10.0.8',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              vitest: '^4.0.14',
            },
            _id: '@opengeoweb-sandbox/timeslider-lite-plugin@0.0.5',
            readmeFilename: 'README.md',
            gitHead: '313425157e1edd758d2eee9aad12ba2070a50a29',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-4V092dT3an2Y3UkSZuXpyni1ec5iN+L4D4HiuFmq/Q0QH5QE7ZHd9uekf5cmQEyiM1oa3EQ+4Cgdt5abCnNEbg==',
              shasum: 'e00fd31cbd9de6ecf8540fb912119cd0c9a8698a',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/timeslider-lite-plugin/-/@opengeoweb-sandbox/timeslider-lite-plugin-0.0.5.tgz',
            },
            contributors: [],
          },
          '0.0.6': {
            name: '@opengeoweb-sandbox/timeslider-lite-plugin',
            version: '0.0.6',
            description: 'Timeslider lite',
            author: {
              name: 'Henrik Janson, Sampo Savolainen, Pauli Sairanen, Sander de Snaijer',
            },
            license: 'Apache-2.0',
            private: false,
            module: 'es2022',
            files: ['dist/bundle.js'],
            geoweb: {
              plugin: {
                type: 'overlay',
                scopes: ['time'],
                bundle: 'dist/bundle.js',
              },
            },
            scripts: {
              storybook: 'storybook dev -p 6006',
              'build-storybook': 'storybook build',
              dev: 'vite dev',
              build: 'vite build',
              preview: 'vite preview',
              'host-plugin': 'vite build --watch & serve --cors -l 3030 dist/',
              test: 'vitest',
              'test:run': 'vitest run',
            },
            dependencies: {
              '@opengeoweb/plugin-interface': '^1.6.2',
              react: '^18.0.0',
              'react-dom': '^18.0.0',
            },
            devDependencies: {
              '@storybook/addon-docs': '^10.0.8',
              '@storybook/react-vite': '^10.2.17',
              '@types/node': '^24.10.1',
              '@types/react': '^19.2.2',
              '@types/react-dom': '^19.2.2',
              '@vitejs/plugin-react': '^4.0.0',
              prettier: '^3.6.2',
              rollup: '^4.57.1',
              serve: '14.2.5',
              storybook: '^10.0.8',
              tsx: '^4.20.6',
              typescript: '^5.9.3',
              vite: '^5.0.0',
              vitest: '^4.0.14',
            },
            _id: '@opengeoweb-sandbox/timeslider-lite-plugin@0.0.6',
            readmeFilename: 'README.md',
            gitHead: 'e30a2cb8ccc8b1f7b7b2ef10fcc1fcb843fb36b4',
            _nodeVersion: '22.22.0',
            _npmVersion: '10.9.4',
            dist: {
              integrity:
                'sha512-GqWbj6wQi/8ndBc6ZR3PqhSlfKttLGXzw5m22nYSHVKmeE3XkXEhq4/cUvIkF946tipt1jcB7NpUooiJvhJVoA==',
              shasum: 'afbe273b668d9894ce919ff23d6883a474f963f8',
              tarball:
                'http://plugins.geoweb.spatineo.com/@opengeoweb-sandbox/timeslider-lite-plugin/-/@opengeoweb-sandbox/timeslider-lite-plugin-0.0.6.tgz',
            },
            contributors: [],
          },
        },
        time: {
          modified: '2026-03-11T09:43:16.871Z',
          created: '2026-02-18T11:53:39.855Z',
          '0.0.1': '2026-02-18T11:53:39.855Z',
          '0.0.2': '2026-02-19T10:03:41.143Z',
          '0.0.3': '2026-02-19T10:26:30.710Z',
          '0.0.4': '2026-03-09T15:21:40.003Z',
          '0.0.5': '2026-03-11T09:32:39.326Z',
          '0.0.6': '2026-03-11T09:43:16.871Z',
        },
        users: {},
        'dist-tags': {
          latest: '0.0.6',
        },
        _uplinks: {},
        _distfiles: {},
        _attachments: {
          'timeslider-lite-plugin-0.0.1.tgz': {
            shasum: '958c4abc255a2551688b8dc29fe99a6d305fd557',
            version: '0.0.1',
          },
          'timeslider-lite-plugin-0.0.2.tgz': {
            shasum: '508a11245c2a6f4459539a3a30a758a673bcb3a4',
            version: '0.0.2',
          },
          'timeslider-lite-plugin-0.0.3.tgz': {
            shasum: 'a018b91ebb1038ff243eee8f6aa9fe3ef085ae0f',
            version: '0.0.3',
          },
          'timeslider-lite-plugin-0.0.4.tgz': {
            shasum: '1b085703c98a027e8595bdba0af0fd9491fc8f14',
            version: '0.0.4',
          },
          'timeslider-lite-plugin-0.0.5.tgz': {
            shasum: 'e00fd31cbd9de6ecf8540fb912119cd0c9a8698a',
            version: '0.0.5',
          },
          'timeslider-lite-plugin-0.0.6.tgz': {
            shasum: 'afbe273b668d9894ce919ff23d6883a474f963f8',
            version: '0.0.6',
          },
        },
        _rev: '18-c706e6824ffbeede',
        _id: '@opengeoweb-sandbox/timeslider-lite-plugin',
        readme:
          '# Timeslider lite plugin\n\nTime slider lite plugin for GeoWeb.\n',
      },
    },
  ],
};
